import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../slices/authSlice';
import '../../DashboardHome/automations.css';

const AUI = {
    pr: (
        <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
            <circle cx="4" cy="4" r="2" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="4" cy="12" r="2" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="1.5" />
            <path d="M4 6v4M12 10V8a2 2 0 00-2-2H7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
    file: (
        <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
            <path d="M4 2.5h5l3 3v8H4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
            <path d="M9 2.5V6h3" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
    ),
    flag: (
        <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
            <path d="M4 14V3M4 3h7l-1.3 2.2L11 8H4" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
        </svg>
    ),
    clock: (
        <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
            <circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.5" />
            <path d="M8 5v3l2 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
    check: (
        <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
            <circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.5" />
            <path d="M5.5 8l1.8 1.8L10.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    comment: (
        <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
            <path d="M2.5 8a5 5 0 015-5h1a5 5 0 015 5v3a1 1 0 01-1 1H8L5 14v-2H3.5a1 1 0 01-1-1V8z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
    ),
    ai: (
        <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
            <path d="M8 2l1.4 3.1L12.5 6 9.4 7.4 8 10.5 6.6 7.4 3.5 6l3.1-.9L8 2z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
        </svg>
    ),
    person: (
        <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
            <circle cx="8" cy="6" r="2.6" stroke="currentColor" strokeWidth="1.5" />
            <path d="M3 13c.8-2.4 2.6-3.6 5-3.6s4.2 1.2 5 3.6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
    bell: (
        <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
            <path d="M4 11V7.5a4 4 0 018 0V11l1 1.5H3L4 11z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
    ),
    export: (
        <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
            <path d="M8 10V3m0 0L5 6m3-3l3 3M3 12.5h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    glossary: (
        <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
            <path d="M3 3h7l3 3v7H3z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
            <path d="M5 7h6M5 9.5h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
    status: (
        <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
            <rect x="2.5" y="4" width="11" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
            <path d="M6 8h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
    arrow: (
        <svg viewBox="0 0 16 12" width="16" height="12" fill="none">
            <path d="M2 6h11M10 2.5L13.5 6 10 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    plus: (
        <svg viewBox="0 0 14 14" width="13" height="13" fill="none">
            <path d="M7 2v10M2 7h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
    ),
    x: (
        <svg viewBox="0 0 14 14" width="12" height="12" fill="none">
            <path d="M3.5 3.5l7 7M10.5 3.5l-7 7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
    ),
    more: (
        <svg viewBox="0 0 14 14" width="14" height="14" fill="none">
            <circle cx="3" cy="7" r="1" fill="currentColor" />
            <circle cx="7" cy="7" r="1" fill="currentColor" />
            <circle cx="11" cy="7" r="1" fill="currentColor" />
        </svg>
    ),
    bolt: (
        <svg viewBox="0 0 16 16" width="16" height="16" fill="none">
            <path d="M9 2L3 9h4l-1 5 6-7H8l1-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
    ),
};

const TRIGGERS = {
    pr: { label: 'Pull request opened', icon: AUI.pr },
    file: { label: 'File added or changed', icon: AUI.file },
    done: { label: 'Project reaches 100%', icon: AUI.check },
    approved: { label: 'Segment approved', icon: AUI.check },
    deadline: { label: 'Deadline approaching', icon: AUI.flag },
    comment: { label: 'Comment or @mention', icon: AUI.comment },
    schedule: { label: 'On a schedule', icon: AUI.clock },
};

const ACTIONS = {
    translate: { label: 'Translate', icon: AUI.ai, cfg: 'into all targets' },
    route: { label: 'Auto-assign', icon: AUI.person, cfg: 'by language' },
    notify: { label: 'Send notification', icon: AUI.bell, cfg: 'to #localization on Slack' },
    export: { label: 'Export & deliver', icon: AUI.export, cfg: 'XLIFF + DOCX' },
    pr: { label: 'Open translation PR', icon: AUI.pr, cfg: 'as a follow-up PR' },
    glossary: { label: 'Run glossary QA', icon: AUI.glossary, cfg: 'block on violations' },
    status: { label: 'Move status', icon: AUI.status, cfg: 'to In review' },
};

const COND_FIELDS = {
    language: { label: 'Language' },
    folder: { label: 'Folder' },
    filetype: { label: 'File type' },
    match: { label: 'TM match below' },
};

const TEMPLATES = [
    { name: 'Localize on every PR', triggerType: 'pr', triggerSource: 'acme/strings', conditions: [{ field: 'filetype', value: 'JSON' }], actions: [{ type: 'translate' }, { type: 'pr' }] },
    { name: 'Auto-route by language', triggerType: 'file', triggerSource: 'Google Drive', actions: [{ type: 'route' }, { type: 'notify' }] },
    { name: 'Ship when complete', triggerType: 'done', actions: [{ type: 'export' }, { type: 'notify' }] },
    { name: 'Glossary guardrail', triggerType: 'approved', conditions: [{ field: 'language', value: 'German' }], actions: [{ type: 'glossary' }, { type: 'notify' }] },
    { name: 'Nightly Figma sync', triggerType: 'schedule', triggerSource: 'Daily · 09:00', actions: [{ type: 'translate' }, { type: 'notify' }] },
    { name: 'Deadline reminder', triggerType: 'deadline', actions: [{ type: 'notify' }] },
];

const Toggle = ({ value, onChange }) => (
    <button
        type="button"
        onClick={() => onChange(!value)}
        style={{
            width: 38, height: 22, borderRadius: 999, border: 0,
            background: value ? 'var(--accent)' : 'var(--bg-soft)',
            position: 'relative', cursor: 'pointer',
        }}
    >
        <span style={{
            position: 'absolute', top: 2,
            left: value ? 18 : 2,
            width: 18, height: 18,
            background: 'white', borderRadius: 999,
            transition: 'left 0.15s',
            boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
        }} />
    </button>
);

const FlowNode = ({ kind, def, sub }) => (
    <div className={`au-node ${kind}`}>
        <span className="au-node-ic">{def.icon}</span>
        <div className="au-node-b">
            <span className="k">{kind === 'trigger' ? 'When' : 'Then'}</span>
            <b>{def.label}</b>
            {sub && <small>{sub}</small>}
        </div>
    </div>
);

const FlowCard = ({ a, onToggle, onDelete }) => {
    const trig = TRIGGERS[a.triggerType] || { label: a.triggerType, icon: AUI.bolt };
    return (
        <div className={`au-card ${a.enabled ? '' : 'off'}`}>
            <div className="au-card-h">
                <span className="au-card-name">{a.name}</span>
                <span className={`au-pill ${a.enabled ? 'on' : 'off'}`}>{a.enabled ? 'Active' : 'Paused'}</span>
                <div className="grow" />
                <Toggle value={a.enabled} onChange={(v) => onToggle(a._id, v)} />
                <button type="button" className="au-more" onClick={() => onDelete(a._id)} aria-label="Delete">{AUI.x}</button>
            </div>
            <div className="au-flow">
                <FlowNode kind="trigger" def={trig} sub={a.triggerSource} />
                {(a.conditions || []).length > 0 && (
                    <>
                        <span className="au-arrow">{AUI.arrow}</span>
                        <span className="au-cond">
                            If {a.conditions.map((c) => `${(COND_FIELDS[c.field] && COND_FIELDS[c.field].label.toLowerCase()) || c.field} ${c.value}`).join(' · ')}
                        </span>
                    </>
                )}
                {(a.actions || []).map((ac, i) => {
                    const adef = ACTIONS[ac.type] || { label: ac.type, icon: AUI.bolt };
                    return (
                        <React.Fragment key={i}>
                            <span className="au-arrow">{AUI.arrow}</span>
                            <FlowNode kind="action" def={adef} sub={ac.config || adef.cfg} />
                        </React.Fragment>
                    );
                })}
            </div>
            <div className="au-card-f">
                Ran <b>{a.runs || 0}</b> times{a.lastRun ? ` · last ${new Date(a.lastRun).toLocaleString()}` : ''}
            </div>
        </div>
    );
};

const Automations = () => {
    const token = useSelector((s) => s.auth.token);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!token) return;
        axios
            .get('/api/automations', { headers: { Authorization: `Bearer ${token}` } })
            .then((r) => { setItems(r.data || []); setLoading(false); })
            .catch((err) => {
                if (err.response && err.response.status === 401) {
                    dispatch(logout());
                    navigate('/login');
                } else {
                    setError('Failed to load automations.');
                    setLoading(false);
                }
            });
    }, [token, dispatch, navigate]);

    const toggle = async (id, enabled) => {
        try {
            await axios.patch(`/api/automations/${id}`, { enabled }, { headers: { Authorization: `Bearer ${token}` } });
            setItems((arr) => arr.map((a) => (a._id === id ? { ...a, enabled } : a)));
        } catch (e) { /* soft */ }
    };

    const remove = async (id) => {
        if (!window.confirm('Delete this automation?')) return;
        try {
            await axios.delete(`/api/automations/${id}`, { headers: { Authorization: `Bearer ${token}` } });
            setItems((arr) => arr.filter((a) => a._id !== id));
        } catch (e) { /* soft */ }
    };

    const addFromTemplate = async (tpl) => {
        try {
            const r = await axios.post('/api/automations', { ...tpl, enabled: true }, { headers: { Authorization: `Bearer ${token}` } });
            setItems((arr) => [r.data, ...arr]);
        } catch (e) {
            setError('Failed to create automation.');
        }
    };

    if (loading) return <div style={{ padding: 40, color: 'var(--ink-3)' }}>Loading automations…</div>;
    if (error) return <div style={{ padding: 40, color: 'crimson' }}>{error}</div>;

    const enabledCount = items.filter((i) => i.enabled).length;
    const totalRuns = items.reduce((s, i) => s + (i.runs || 0), 0);

    return (
        <>
            <div className="rs-page-title-row">
                <h1 className="rs-page-title">Automations</h1>
                <span className="rs-page-title-count">{items.length}</span>
            </div>
            <p className="rs-page-sub">Continuous-localization rules that move work without you. When X happens, do Y.</p>

            <div className="au-stats">
                <div className="au-stat">
                    <div className="v">{items.length}<span className="u">total</span></div>
                    <div className="l">Automations</div>
                </div>
                <div className="au-stat">
                    <div className="v">{enabledCount}<span className="u">active</span></div>
                    <div className="l">Currently running</div>
                </div>
                <div className="au-stat">
                    <div className="v">{totalRuns.toLocaleString()}<span className="u">runs</span></div>
                    <div className="l">All time</div>
                </div>
                <div className="au-stat">
                    <div className="v">{TEMPLATES.length}<span className="u">ready</span></div>
                    <div className="l">Templates available</div>
                </div>
            </div>

            <div className="rs-card" style={{ marginBottom: 16 }}>
                <div className="rs-card-h">
                    <h3>Your automations</h3>
                </div>
                {items.length === 0 ? (
                    <div style={{ padding: 24, color: 'var(--ink-3)', fontSize: 13 }}>
                        Nothing yet. Pick a template below to get started.
                    </div>
                ) : (
                    <div className="au-list">
                        {items.map((a) => (
                            <FlowCard key={a._id} a={a} onToggle={toggle} onDelete={remove} />
                        ))}
                    </div>
                )}
            </div>

            <div className="rs-card">
                <div className="rs-card-h">
                    <h3>Templates</h3>
                    <span className="count">{TEMPLATES.length}</span>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 12 }}>
                    {TEMPLATES.map((tpl) => (
                        <button
                            type="button"
                            key={tpl.name}
                            onClick={() => addFromTemplate(tpl)}
                            style={{
                                background: 'var(--bg-soft)',
                                border: '1px solid var(--line)',
                                borderRadius: 12,
                                padding: 14,
                                textAlign: 'left',
                                cursor: 'pointer',
                                color: 'inherit',
                                fontFamily: 'inherit',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 8,
                            }}
                        >
                            <b style={{ fontSize: 13.5, color: 'var(--ink)' }}>{tpl.name}</b>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', fontSize: 11.5, color: 'var(--ink-3)' }}>
                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                    {TRIGGERS[tpl.triggerType]?.icon}
                                    {TRIGGERS[tpl.triggerType]?.label}
                                </span>
                                {tpl.actions.map((a, i) => (
                                    <React.Fragment key={i}>
                                        {AUI.arrow}
                                        <span>{ACTIONS[a.type]?.label}</span>
                                    </React.Fragment>
                                ))}
                            </div>
                            <span style={{ fontSize: 11, color: 'var(--accent)', fontWeight: 700 }}>+ Add this rule</span>
                        </button>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Automations;
